module.exports = __webpack_public_path__ + "img/full5-min.232e1a54.png";